import yup from '../libraries/validator.library';
export const MassUpdateResponseSchema = yup.object({
    message: yup.string(),
    data: yup.array(),
    status: yup.boolean(),
});

export type IMassUpdateResponse = yup.InferType<
    typeof MassUpdateResponseSchema
>;
